export const stopServeUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  browserTab,
  setBrowserTab,
}) => {
  const freshToken = await getFreshToken();
  const response = await fetch(getEndpointUrl() + `/stopServe`, {
    headers: {
      Authorization: `Bearer ${freshToken}`,
    },
  });

  if (!response.ok) {
    throw new Error("Error stopping the React app.");
  }

  console.log("React app has been stopped.");

  if (browserTab && !browserTab.closed) {
    browserTab.close();
    console.log("Closed existing browser tab.");
  }

  setBrowserTab(null);
  console.log("Cleared browserTab state.");

  return "App stopped successfully";
};
